import { createContext } from 'react';
import { PolicyModificationOptions } from '@src/@types/policies';
export const PolicyModificationOptionsContext = createContext<
  PolicyModificationOptions[]
>([]);
